import React, { useState } from "react";
import Loader from "../Loader/Loader";
import { message } from "antd";
import { bulkUpload } from "../../Web Apis/Apis";
import { FaDownload } from "react-icons/fa";
import * as XLSX from "xlsx";

const BulkUpload = ({ setShowModal, action, setAction }) => {
  const [excelFile, setExcelFile] = useState(null);
  const [Loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setExcelFile(e.target.files[0]);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await bulkUpload(excelFile);
      if (response?.data?.success) {
        message?.success(response?.data?.message);
        setShowModal(false);
        setAction(!action);
      }
    } catch (error) {
      console.log("Error in bulk upload", error);
      message.error(error?.response?.data?.message || "Error occured");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadStructure = () => {
    const columnHeaders = [
      "ID",
      "Title",
      "Gift Type",
      "Occasion",
      "Relationship",
      "Gender",
      "Age Group",
      "Hobbies/Interests",
      "Personality Type",
      "Location/Season",
      "Personalization",
      "Delivery Timeframe",
      "Emotional Impact",
      "Life Stages",
      "Coin",
      "Voucher Type",
      "Template Json",
      "Description",
      "Preview Image Url",
    ];

    // Create a worksheet with headers only (empty first row with keys)
    const worksheet = XLSX.utils.aoa_to_sheet([columnHeaders]);

    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Gift Template");

    // Trigger download
    XLSX.writeFile(workbook, "gift_template_structure.xlsx");
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white  rounded-lg shadow-lg w-[400px] h-[250px] overflow-y-auto">
        <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-blue-950 to-blue-500 py-2 text-white">
          Upload voucher sheet
        </h3>

        <form onSubmit={(e) => handleUpload(e)} className="p-8">
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileChange}
            className="mb-4 w-full border p-2 rounded"
          />

          <div className=" flex justify-center gap-6 mt-6">
            <button
              type="button"
              onClick={handleDownloadStructure}
              className="bg-green-200 text-black min-w-fit py-2 px-4 rounded-md hover:bg-yellow-200 transition duration-200 flex items-center justify-center gap-1 whitespace-nowrap"
            >
              <span>Excel Format</span> <FaDownload />
            </button>

            <button
              onClick={() => setShowModal(false)}
              className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              {Loading ? "Uploading..." : "Upload"}
            </button>
          </div>
        </form>

        {Loading && <Loader />}
      </div>
    </div>
  );
};

export default BulkUpload;
